import React from 'react';
import TooltipTrigger from 'react-popper-tooltip';
import styles from './ProductSidebar.module.scss';
import VerifiedIcon from './assets/verified-icon.svg';

interface ITooltipProps {
  arrowRef: Function;
  tooltipRef: Function;
  getArrowProps: Function;
  getTooltipProps: Function;
  placement: string;
}

interface ITriggerProps {
  getTriggerProps: Function;
  triggerRef: Function;
}

interface IPriceMatchGuaranteeProps {
  className?: string;
}

const Tooltip = ({
  arrowRef,
  tooltipRef,
  getArrowProps,
  getTooltipProps,
  placement
}: ITooltipProps | any): React.ReactNode => (
  <div
    {...getTooltipProps({
      style: { zIndex: 501 },
      ref: tooltipRef,
      className: `${styles['o-product-sidebar__tooltip-container']} tooltip-container my-2 ml-3`,
      'data-test': 'product-sidebar_price-match-tooltip'
    })}
  >
    <div
      {...getArrowProps({
        ref: arrowRef,
        className: `${styles['o-product-sidebar__tooltip-arrow']} tooltip-arrow`,
        'data-placement': placement
      })}
    />
    <h3 className={`h5 pt-2`}>Price Verification Guarantee</h3>
    <div data-test="product-sidebar_price-match-tooltip-content">
      Find a different price? We’ll honor the lower price for the same product
      on our Vendor Partners’ sites. Just request it in your cart. Visit our
      help center for more information on our policy. Exclusions apply.
    </div>
  </div>
);

const Trigger = ({
  getTriggerProps,
  triggerRef
}: ITriggerProps | any): React.ReactNode => (
  <div
    {...getTriggerProps({
      ref: triggerRef,
      className: `${styles['o-product-sidebar__tooltip-trigger']} trigger ml-2`,
      'data-test': 'product-sidebar_price-match-trigger'
    })}
  >
    <VerifiedIcon />
  </div>
);

const PriceVerificationGuarantee = ({
  className = undefined
}: IPriceMatchGuaranteeProps) => (
  <div
    className={`${styles['o-product-sidebar__price-match']} d-flex align-items-center ${className}`}
    data-test="product-sidebar_price-match"
  >
    <span>
      Price Verification Guarantee
    </span>

    <TooltipTrigger placement="bottom" trigger="hover" tooltip={Tooltip}>
      {Trigger}
    </TooltipTrigger>
  </div>
);

export { Tooltip };

export default PriceVerificationGuarantee;
